var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M11.9886 8.01124C13.0869 9.10956 13.0869 10.8903 11.9886 11.9886C10.8903 13.0869 9.10956 13.0869 8.01124 11.9886C6.91292 10.8903 6.91292 9.10956 8.01124 8.01124C9.10956 6.91292 10.8903 6.91292 11.9886 8.01124",
    stroke: "#21201D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2047 1.13522L13.8606 1.35346C14.4613 1.55371 14.8674 2.11619 14.8674 2.74955V3.69115C14.8674 4.49213 15.5064 5.14573 16.3074 5.16261L17.2501 5.18286C17.7957 5.19411 18.2907 5.50797 18.5348 5.99621L18.8442 6.61494C19.1277 7.18193 19.0163 7.86591 18.5686 8.31364L17.9026 8.97963C17.3367 9.54549 17.3266 10.4601 17.8801 11.0383L18.5326 11.72C18.9106 12.1149 19.0388 12.6853 18.8656 13.2039L18.6473 13.8597C18.4471 14.4605 17.8846 14.8666 17.2512 14.8666H16.3096C15.5086 14.8666 14.855 15.5056 14.8382 16.3065L14.8179 17.2493C14.8067 17.7949 14.4928 18.2899 14.0046 18.534L13.3858 18.8434C12.8188 19.1268 12.1349 19.0155 11.6871 18.5677L11.0211 17.9018C10.4553 17.3359 9.54069 17.3258 8.96245 17.8793L8.28072 18.5317C7.88586 18.9097 7.3155 19.038 6.79689 18.8647L6.14103 18.6465C5.5403 18.4462 5.13419 17.8838 5.13419 17.2504V16.3088C5.13419 15.5078 4.4952 14.8542 3.69423 14.8373L2.7515 14.8171C2.20589 14.8058 1.71091 14.492 1.46679 14.0037L1.15742 13.385C0.873931 12.818 0.985303 12.134 1.43304 11.6863L2.09902 11.0203C2.66488 10.4545 2.67501 9.53986 2.12152 8.96163L1.46904 8.2799C1.08992 7.88391 0.961678 7.31242 1.13492 6.79494L1.35317 6.13908C1.55341 5.53835 2.1159 5.13223 2.74925 5.13223H3.69085C4.49183 5.13223 5.14544 4.49325 5.16231 3.69227L5.18256 2.74955C5.19606 2.20394 5.5088 1.70895 5.99704 1.46484L6.61577 1.15547C7.18275 0.871978 7.86674 0.983349 8.31447 1.43109L8.98045 2.09707C9.54631 2.66293 10.4609 2.67305 11.0391 2.11957L11.7209 1.46709C12.1157 1.09022 12.6872 0.961975 13.2047 1.13522V1.13522Z",
    stroke: "#21201D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.95ec7bcd2c96da634f4594a80e03fa10.svg";
export { ForwardRef as ReactComponent };